import { createTRPCClient, useClientQueryHooks } from '@newfront-insurance/data-layer-client';
import { createProvider, useProvider } from '@newfront-insurance/react-provision';

const AdminTRPCProvider = createProvider(options => {
  const {
    authProvider,
    basePath
  } = options;
  const {
    getToken
  } = useProvider(authProvider);
  const client = createTRPCClient({
    getToken,
    url: basePath
  });
  return useClientQueryHooks(client);
}); // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type

function useAdminTRPC() {
  return useProvider(AdminTRPCProvider);
}

export { AdminTRPCProvider as A, useAdminTRPC as u };
